import type { SearchConfig, SearchState, SearchStateAction } from "src/claimsHistory/types";

/**
 * The unsearched state the page renders before any submission. Nothing is read
 * from the URL: a route's query parameters are disregarded and left untouched,
 * so a reload or a pasted link lands here rather than restoring a search.
 */
export function initialSearchState(config: SearchConfig): SearchState {
  return {
    selectedFieldId: config.searchableFields[0].fieldId,
    term: "",
    dateRange: null,
    submissionId: 0,
    validationMessage: null,
  };
}

export function searchStateReducer(state: SearchState, action: SearchStateAction): SearchState {
  switch (action.type) {
    case "selectField":
      // Term and range belong to the field they were entered against, so a
      // field change starts clean. submissionId survives: it identifies
      // submissions, and a field change is not one.
      return {
        ...state,
        selectedFieldId: action.fieldId,
        term: "",
        dateRange: null,
        validationMessage: null,
      };

    case "setTerm":
      return { ...state, term: action.term };

    case "setDateRange":
      return { ...state, dateRange: action.dateRange };

    case "submit":
      return {
        ...state,
        submissionId: state.submissionId + 1,
        validationMessage: null,
      };

    case "reject":
      // Only the message changes. The page keys its dispatch off a change in
      // submissionId, so bumping it here would issue a search for the term
      // that was just rejected.
      return { ...state, validationMessage: action.message };
  }
}
